import React from "react";
import { SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";
import { ROW_CLASSES_ITEM, ROW_CLASSES_SHARED } from "./utils";

export const CostSummaryLoader = () => {
  return Array.from({ length: 7 }).map((_, index) => {
    return (
      <div
        key={index}
        className={classNames(ROW_CLASSES_ITEM, ROW_CLASSES_SHARED)}
        data-testid="cost-summary-loader"
      >
        <SkeletonLoader className="tw-h-4 tw-w-full" />
        <SkeletonLoader className="tw-h-4 tw-w-full" />
        <SkeletonLoader className="tw-h-4 tw-w-full" />
        <SkeletonLoader className="tw-h-4 tw-w-full" />
      </div>
    );
  });
};
